import React from 'react'
import styles from './alert.module.scss'
import clsx from 'clsx'
import Icon from '../Icon'
import Typography from '../Typography'
import * as PropTypes from 'prop-types'
import { Button, Grid } from '../index'

const Alert = ({
  className,
  children,
  onClose = null,
  severity = 'info',
  variant = 'filled',
  ...rest
}) => (
  <Grid
    direction={'row'}
    alignItems={'center'}
    {...rest}
    className={clsx(
      className,
      styles['alert'],
      styles[`${variant}`],
      styles[`${variant}-severity--${severity}`],
    )}
    wrap={false}
    fluid
    justifyContent={'space-between'}
    gap={24}
  >
    <Typography
      variant={'Body-20'}
      className={styles['alert__text']}
      noMargin
      component={'div'}
    >
      {children}
    </Typography>

    {typeof onClose === 'function' && (
      <Button
        noHover
        ghost
        noLabel
        onClick={onClose}
        className={styles['alert__close-btn']}
        startIcon={
          <Icon name={'close'} color={'basic-primary-white'} size={'m'} />
        }
      />
    )}
  </Grid>
)

Alert.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  onClose: PropTypes.func,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  variant: PropTypes.oneOf(['filled', 'outlined']),
}

export default Alert
